__turbopack_context__.v({
  "backdrop": "InfoCard-module-scss-module__5-mJZa__backdrop",
  "button": "InfoCard-module-scss-module__5-mJZa__button",
  "buttonSection": "InfoCard-module-scss-module__5-mJZa__buttonSection",
  "buttonSectionWrapper": "InfoCard-module-scss-module__5-mJZa__buttonSectionWrapper",
  "fullWidth": "InfoCard-module-scss-module__5-mJZa__fullWidth",
  "illustrationBorder": "InfoCard-module-scss-module__5-mJZa__illustrationBorder",
  "illustrationWrapper": "InfoCard-module-scss-module__5-mJZa__illustrationWrapper",
  "mainCard": "InfoCard-module-scss-module__5-mJZa__mainCard",
  "textWrapper": "InfoCard-module-scss-module__5-mJZa__textWrapper",
});
